import React from 'react';

import { intlGet } from 'utils/intlGet';
import { TextPlaceholderProps } from './models';
import styles from './styles.module.scss';

const TextPlaceholder: React.FunctionComponent<TextPlaceholderProps> = (props) => {
  const { text = intlGet('Artboard.Layout.Text', 'Hint') } = props;
  if (!text) {
    return null;
  }

  return (
    <div className={styles.TextPlaceholder}>
      {text}
    </div>
  );
};

export default TextPlaceholder;
